import type { FC } from 'react';
import useLanguageChange from 'src/common/hooks/useLanguageChange';
import LanguageSelector from '../LanguageSelector';
import ComponentWrapper from '../NestedMenu/ComponentWrapper';

const LanguageSelectorNavItem: FC = () => {
  const { onLanguageChange } = useLanguageChange();

  return (
    <ComponentWrapper>
      <LanguageSelector
        onChange={onLanguageChange}
        fullWidth
      />
    </ComponentWrapper>
  );
};
export default LanguageSelectorNavItem;
